import { LAYOUT_FIELD_TYPES } from '@cli-constants/schema.js'

export function isLayoutField(type: string): boolean {
  return (LAYOUT_FIELD_TYPES as readonly string[]).includes(type)
}
